import styled from 'styled-components';
import { Typography } from '@mui/material';

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CardTitle = styled(Typography)`
  font-weight: 400;
  font-size: 24px;
`;
